<template>
  <div>
    <Breadcrumbs main="" title="shipShore.header" />
    <b-container fluid>
      <!-- <h3 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.header') }}</h3> -->
      <div>
        <div>
          <div class="d-flex flex-row justify-content-between mx-3 my-1">
            <h2 class="mb-1 mt-1 ml-3 f-w-600">{{ $t('logistShore.logistShore') }}</h2> 
            <b-button
                pill
                variant="primary"
                size="lg"
                class="float-right"
                @click="exportAccept2Port_excel"
                v-b-popover.hover.top="$t('shipShore.exportShore2PortMsg')"
              >
                {{ $t('shipShore.exportShoreBtn') }}
              </b-button>
          </div>
          <b-row>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select-shipShore"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    :aria-describedby="ariaDescribedby"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select-shipShore"
                  v-model="sortDirection"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input-shipShore"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                v-model="sortDirection"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="bkgId">{{ $t('matchTx.bkgId') }}</b-form-checkbox>
                  <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>     
                  <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                  <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                  <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                  <b-form-checkbox value="sealNo">{{ $t('matchTx.sealNo') }}</b-form-checkbox>  
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="row justify-content-start ml-2">
            <feather 
                @click="refresh" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
            </feather>  
              <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
              <span class="text-primary"> {{ asOf }} </span>   
          </div>
          <b-table
            sticky-header
            head-variant="light"
            table-variant="info"
            show-empty
            sort-icon-left
            stacked="md"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFiltered"
          >
            <template #cell(actShore)="row" >
              <b-button v-show="row.item.status != 'accept'"  size="sm" variant="warning" @click="actShoreEdit(row.item)" class="m-1">
                {{ $t('approvedTrans.edit') }}
              </b-button>
              <b-button  v-show="row.item.status == 'waitAccept'" size="sm" variant="danger" @click="actShoreCancel(row.item)" class="m-1 ">
              {{ $t('matchTx.cancel') }}
            </b-button>
            </template>
            <template #empty>
                <h5>{{ $t('reuse.noRecord') }}</h5>
            </template>
          </b-table>
          <b-row>
            <div class="row col-sm-4 ">
              <b-col class="my-1 ml-3">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  class="my-0"
                ></b-pagination>
              </b-col>   
              <b-col sm="3" md="6" class="my-1">
                <b-form-group
                  :label= "$t('require.perPage')"
                  label-for="per-page-select"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </div>
          </b-row>                     
        </div>
        <b-modal
          id="shoreEdit-modal" 
          :title="$t('shipShore.shoreEditConsdModalTitle')"
          v-model="showShoreEditModal"
          header-bg-variant="info"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          hide-footer
        >
          <div class="form-row">
              <h3 class="text-primary ml-3">{{ $t('logistShore.shoreEditData') }}</h3>
              <div class="d-flex flex-row justify-content-between mx-2">
                  <div class="form-group col-md-6">
                      <label for="vessel" class="col-form-label text-primary f-w-600">{{ $t('shipShore.vessel') }}</label>
                      <input class="form-control" id="vessel" v-model="selectedItem.vessel" type="text" disabled>
                  </div>
                  <div class="form-group col-md-6">
                      <label for="voyageNo" class="col-form-label text-primary f-w-600">{{ $t('shipShore.voyageNo') }}</label>
                      <input class="form-control" id="voyageNo" v-model="selectedItem.voyageNo" type="text" disabled>
                  </div>                  
              </div>                
              <div class="d-flex flex-row justify-content-between mx-2">
                <div class="form-group col-md-6">
                    <label for="destPort" class="col-form-label text-primary f-w-600">{{ $t('matchTx.destPort') }}</label>
                    <input class="form-control" id="destPort" v-model="selectedItem.destPort" type="text">
                </div>
                <div class="form-group col-md-6">
                    <label for="cargoWeight" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoWeight') }}</label>
                    <input class="form-control" id="cargoWeight" v-model="selectedItem.cargoWeight" type="number" >
                </div>                
              </div>                
              <div class="col-md-12 ml-3">
                  <div class="form-group">
                      <label for="cargoDesc" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoDesc') }}</label>
                      <input class="form-control" id="cargoDesc" v-model="selectedItem.cargoDesc" type="text" >
                  </div>
              </div>
              <div class="col-md-12 ml-3">
                  <div class="form-group">
                      <label for="cargoOwner" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoOwner') }}</label>
                      <label for="cargoDesc" class="col-form-label text-primary f-w-600">{{ $t('matchTx.cargoDesc') }}</label>
                      <input class="form-control" id="cargoOwner" v-model="selectedItem.cargoOwner" type="text" >
                  </div>
              </div>                
              <div class="col-md-12 ml-3">
                <div class="form-group">
                  <label for="remark" class="col-form-label text-primary f-w-600">{{ $t('shipApproval.rejectRemark') }}</label>
                  <input
                    class="form-control"
                    id="remark-input"
                    v-model="selectedItem.remark"
                    type="text"
                    :placeholder="$t('shipApproval.rejectRemarkPh')"
                    style="font-size: 16px;"
                  >                  
                </div>
            </div>
          </div>
          <div class="w-100">
            <b-button
              variant="primary"
              size="md"
              class="float-right"
              @click="clickShoreEdit_OK"
            >
            {{ $t('truck.ok') }}
            </b-button>              
            <b-button
              variant="warning"
              size="md"
              class="float-right"
              @click="clickShoreEdit_NO"
            >
              {{ $t('matchTx.no') }}
            </b-button>
          </div>
        </b-modal>                       
        <b-modal
        id="exportXls-modal" 
        :title="$t('shipShore.exportXlsModalTitle')"
        v-model="showExportXlsModal"
        header-bg-variant="primary"
        header-text-variant="white"
        body-bg-variant="light"
        body-text-variant="dark"
        size = lg
        hide-footer
        >
        <div class="row mx-3 my-2">
          <label class="f-w-600 mx-2 mt-2" style="font-size:16px;">{{ $t("bill.startDate") }} :</label>
            <datepicker 
              v-model="startDate"
              input-class="datepicker-here form-control digits" 
              :disabled-dates="disabledDates"
              :placeholder="$t('shipShore.startDatePh')"
              :format="format"  >
            </datepicker>
        </div> 
        <div class="w-100">
          <b-button
            variant="primary"
            size="md"
            class="float-right mx-2 mt-2"
            @click="clickAllStatus_Export"
          >
          {{ $t('shipShore.allStatusExport') }}
          </b-button>
          <b-button
            variant="primary"
            size="md"
            class="float-right mx-2 mt-2 "
            @click="clickAcceptStatus_Export"
          >
          {{ $t('shipShore.acceptStatusExport') }}
          </b-button>      
          <b-button
            variant="primary"
            size="md"
            class="float-right mx-2 mt-2 "
            @click="clickWaitAcceptStatus_Export"
          >
          {{ $t('logistShore.waitAcceptStatusExport') }}
          </b-button>      
          <b-button
            variant="warning"
            size="md"
            class="float-right mr-2 mt-2"
            @click="clickExport_NO"
          >
            {{ $t('matchTx.no') }}
          </b-button>
        </div>
        </b-modal>  
      </div>
    </b-container>
  </div>
</template>
<script>

import { shoreCompIdStartDate , mergeObj, updateStatus } from "../../firebase"
import {exportXlsx } from "../../utilities/util" 
  export default {
    name: 'logistShore',
    data() {
      return {
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        compId : '',
        compNameEng : '',
        logistShoreStartDateTS : 0,
        items: [],
        fields: [
          { key: 'shoreId', label: this.$t('logistShore.shoreId'), sortable: true, },  
          { key: 'vessel', label: this.$t('shipShore.vessel'), sortable: true, variant: 'warning'},
          { key: 'voyageNo', label: this.$t('shipShore.voyageNo'), sortable: true, variant: 'warning' },
          { key: 'destPort', label: this.$t('matchTx.destPort'), sortable: true, variant: 'warning' }, 
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, variant: 'warning' },                
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, variant: 'warning' },     
          { key: 'contNo', label: this.$t('matchTx.contNo'), sortable: true, variant: 'success'},       
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true, variant: 'success'},
          { key: 'contSize', label: this.$t('matchTx.contSize'), sortable: true, variant: 'success'},
          { key: 'contGrade', label: this.$t('matchTx.contGrade'), sortable: true, variant: 'success' },
          { key: 'tare', label: this.$t('container.tare'), sortable: true, variant: 'success' },
          { key: 'sealNo', label: this.$t('matchTx.sealNo'), sortable: true,  variant: 'success' },
          { key: 'cargoDesc', label: this.$t('matchTx.cargoDesc'), sortable: true, },
          { key: 'cargoWeight', label: this.$t('matchTx.cargoWeight'), sortable: true, },
          { key: 'cargoOwner', label: this.$t('matchTx.cargoOwner'), sortable: true, },   
          { key: 'compNameLocalReqr', label: this.$t('shipShore.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'status', label: this.$t('approvedTrans.transStatus'), sortable: true,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          } },
          { key: 'actShore', label: this.$t('shipShore.actShore'), sortable: true, variant: 'primary'},  
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},   
        ],
        isBusy: false,   
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortBy: 'timestamp',
        sortDesc: true,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        selectedItem: '',
        showShoreEditModal : false,        
        shoreId : '',
        destPort: '',
        cargoDesc: '',
        cargoWeight: null,
        cargoOwner: '',
        remark : '',
        showExportXlsModal : false,
        format: "yyyy MM dd",
        startDate : '',
        disabledDates: {
          to : new Date(Date.parse(new Date())-2678400000),
          from: new Date(Date.parse(new Date())),
        },
      }
    },
    computed: {
      sortOptions() {
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
    
    mounted() {
      this.compId= localStorage.getItem("compId")
      this.logistShoreStartDateTS = Date.parse(new Date()) - 7905600000 // 3 months back
        shoreCompIdStartDate(this.compId,  [ "waitAccept" , "accept" , "reject" , "cancel" ], this.logistShoreStartDateTS, (res)=>{
          this.items = res
          this.totalRows = res.length
        })
    },
    methods: {
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      async refresh() {
        this.selectedItem = ''
        this.isBusy = true
        await shoreCompIdStartDate(this.compId, [ "waitAccept" , "accept" , "reject" , "cancel" ], this.logistShoreStartDateTS ,(res)=>{
          this.items = res
          this.totalRows = res.length
          this.isBusy = false
        })
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },

      async actShoreEdit(item) {
        this.selectedItem = item
        this.showShoreEditModal = true
      },
      clickShoreEdit_NO(){
        this.selectedItem = ''
        this.showShoreEditModal = false
      },
      async clickShoreEdit_OK(){
        let msg = 'completed'
        if (this.selectedItem.cargoDesc ===''){
            msg = 'matchTx.addCargoDesc'
        } else if (this.selectedItem.cargoOwner ===''){
            msg = 'matchTx.addCargoOwner'                        
          } else if (this.selectedItem.destPort ==='') {
            msg = 'matchTx.addDestPort'
        } else if (this.selectedItem.cargoWeight <= 0){
            msg = 'matchTx.addCargoWeight'
        }  
        if (msg === 'completed'){
          let payload = {
              vessel : this.selectedItem.vessel,
              voyageNo : this.selectedItem.voyageNo,
              destPort : this.selectedItem.destPort,    
              remark: this.selectedItem.remark,
              cargoDesc: this.selectedItem.cargoDesc,
              cargoWeight: this.selectedItem.cargoWeight,
              cargoOwner: this.selectedItem.cargoOwner,
              status : 'waitAccept',
              timestamp: Date.parse(new Date()),
          }
          await mergeObj('Shore', this.selectedItem.shoreId, payload).then( async()=>{
          await this.refresh()
          this.showShoreEditModal = false                 
          })       
          await mergeObj('MatchTx', this.selectedItem.shoreId ,{
            shoreStatus : 'waitAccept',
            timestamp: Date.parse(new Date())
          })   
       
          this.$toasted.show(this.$t('shipShore.successAcceptShore'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 8000});       
        }else{
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }  
      },
      actShoreCancel(item) {
        this.$bvModal.msgBoxConfirm(this.$t('shipShore.confirmCancelMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              await updateStatus( 'Shore' , item.shoreId , 'cancel')
              await mergeObj('MatchTx', item.shoreId ,{
                shoreStatus : 'cancel',
                timestamp: Date.parse(new Date())
              })  
              await this.refresh()
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Cancel- Shore : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },   
      async exportAccept2Port_excel(){
        this.showExportXlsModal = true
      },
      clickExport_NO(){
        this.showExportXlsModal = false
      },
      async clickWaitAcceptStatus_Export(){
        if (this.startDate == '') {
          this.$toasted.show(this.$t('shipShore.addStartDate'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
        } else {
          await shoreCompIdStartDate(this.compId, ["waitAccept"],  Date.parse(this.startDate), (res)=>{
            if (res.length == 0) {
              this.$toasted.show(this.$t('shipShore.noShoreRequestWaitAccept'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
            } else {
              exportXlsx(res , `SHORE-${this.$moment().format("YYYY-MM-DD-HH-mm")}`)
              this.showExportXlsModal = false
            }
          })          
        }
      },
      async clickAcceptStatus_Export(){
        if (this.startDate == '') {
          this.$toasted.show(this.$t('shipShore.addStartDate'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
        } else {
          await shoreCompIdStartDate(this.compId, ["accept"],  Date.parse(this.startDate), (res)=>{
            // console.log(`res,clickAcceptStatus_Export=> ${JSON.stringify(res, null , 2)}`)
            if (res.length == 0) {
              this.$toasted.show(this.$t('shipShore.noShoreRequestAccept'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
            } else {
              exportXlsx(res , `SHORE-${this.$moment().format("YYYY-MM-DD-HH-mm")}`)
              this.showExportXlsModal = false
            }
          })          
        }
      },
      async clickAllStatus_Export(){
        if (this.startDate == '') {
          this.$toasted.show(this.$t('shipShore.addStartDate'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
        } else {
          await shoreCompIdStartDate(this.compId, ["waitAccept" ,"accept" , "reject" , "cancel" ],  Date.parse(this.startDate), (res)=>{
            // console.log(`res,clickAllStatus_Export=> ${JSON.stringify(res, null , 2)}`)
            if (res.length == 0) {
            this.$toasted.show(this.$t('shipShore.noShoreRequestAll'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
            } else {
              exportXlsx(res , `SHORE-${this.$moment().format("YYYY-MM-DD-HH-mm")}`)
              this.showExportXlsModal = false
            }              
          })
        }
      },
    }
  }
</script>
